import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronRightIcon } from "lucide-react";
import type { FC, ReactNode } from "react";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	icon: ReactNode;
	iconBg: string;
	title: string;
	description?: string;
	onClick: () => void;
};

export const CtaCard: FC<Props> = ({
	icon,
	iconBg,
	title,
	description,
	onClick,
}) => {
	const theme = useTheme();

	return (
		<Stack
			component="button"
			type="button"
			direction="row"
			alignItems="center"
			gap={theme.spacingTokens.md}
			onClick={onClick}
			sx={{
				width: "100%",
				p: theme.spacingTokens.lg,
				bgcolor: "background.paper",
				borderRadius: "16px",
				border: `1px solid ${theme.palette.grey[100]}`,
				appearance: "none",
				cursor: "pointer",
				textTransform: "none",
				transition: "background-color 200ms",
				"&:active": { bgcolor: theme.palette.grey[50] },
			}}
		>
			<IconBox bg={iconBg}>{icon}</IconBox>
			<Stack flex={1} minWidth={0} textAlign="left">
				<Typography variant="bodyMedium" color={theme.palette.grey[800]}>
					{title}
				</Typography>
				{description && (
					<Typography
						variant="caption"
						color={theme.palette.grey[500]}
						mt={0.2}
					>
						{description}
					</Typography>
				)}
			</Stack>
			<ChevronRightIcon
				size={theme.iconSize.sm}
				color={theme.palette.grey[400]}
			/>
		</Stack>
	);
};
